import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { NoAuthGuard } from 'src/guards/no-auth-guard';
import { Layout as LandingLayout } from 'src/layouts/landing';

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const LoginPage = lazy(() => import('src/pages/auth/login'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const StartPage = lazy(() => import('src/pages/auth/firebase/start'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const FirebaseActionsPage = lazy(() => import('src/pages/auth/firebase/actions'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const RecoverPasswordPage = lazy(() => import('src/pages/auth/firebase/recover-password'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const MagicLinkPage = lazy(() => import('src/pages/auth/firebase/magic-link'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const OidcCallbackPage = lazy(() => import('src/pages/auth/oidc/callback'));

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <NoAuthGuard>
        <LandingLayout>
          <Outlet />
        </LandingLayout>
      </NoAuthGuard>
    ),
    children: [
      {
        path: 'start',
        element: <StartPage />
      },
      {
        path: 'login',
        element: <LoginPage />
      },
      {
        path: 'create',
        element: <FirebaseActionsPage mode="create" />
      },
      {
        path: 'reset',
        element: <FirebaseActionsPage mode="reset" />
      },
      {
        path: 'recover',
        element: <RecoverPasswordPage />
      },
      {
        path: 'redirect',
        element: <MagicLinkPage />
      }
    ]
  },
  {
    path: 'oidc',
    element: (
      <LandingLayout>
        <Outlet />
      </LandingLayout>
    ),
    children: [
      {
        path: 'callback',
        element: <OidcCallbackPage />
      }
    ]
  }
];
